interface CVSection {
  id: string;
  label: string;
}

export const CV_SECTIONS: CVSection[] = [
  { id: 'personal-details', label: 'Personal Details' },
  { id: 'roles-overview', label: 'Roles overview' },
  { id: 'summary-qualifications', label: 'Summary of Qualifications' },
  { id: 'project-experience', label: 'Project Experience' },
  { id: 'skills-overview', label: 'Skills overview' },
  { id: 'education', label: 'Education' },
  { id: 'work-experience', label: 'Work Experience' },
  { id: 'certifications', label: 'Certifications' },
  { id: 'languages', label: 'Languages' },
  { id: 'training-courses', label: 'Training and Courses' }
];

